import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as selectores from "app/features/selectores/simples";
import { validation, formfields } from "kea-react"
import { componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";

type Entity = models.InfoComEnvio;
export interface Props {
    value: Entity;
    title: string;
    style?: "default" | "primary" | "success" | "info" | "warning" | "danger";
    format?: "decimal" | "int" | "currency" | "percentage" | "int-2-digit";
    onChange: (value: Entity) => PromiseLike<void>;
    readonly?: boolean;
    error?: kea.FieldError;
}

/**
* Componente para editar un Entity
*/
class InfoComEnvioComponentNoRx extends React.PureComponent<Props> {
    value = (props: Props) => this.props.value;
 
    errors = () => validation.getErrors(this.rules, this.props.value);

    getField = formfields(() => this.props, () => this.errors());

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value , title, style } = this.props;
        const getField = this.getField;
        const Number = getField(kea.Number);
        const Text = getField(kea.Text);
        const GiroEmpresa = getField(selectores.GiroEmpresa);
        const Clasificacion = getField(selectores.Clasificacion);

        return (
            <div>
                <kea.Panel title={title} iconClass={fa("info-circle")} style={style} >
                    {kea.autogrid(6, [
                        <Number field="RAD" label="RAD" format={this.props.format}/>,
                        <Number field="Mostrador" label="Mostrador" format={this.props.format} />,                        
                    ])}
                </kea.Panel>
            </div>);
    }
}

export const InformacionComercialEnvioComponent = componentToRx(kea.mapProps(InfoComEnvioComponentNoRx, x => ({ ...x, value: x.value || {} })), <kea.Spinner />, undefined, {
    error: { ignore: { observable: true, promise: true } }
});


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/edit/informacioncomercial/informacionPorMes/componentes/informacionenviadas.tsx